import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Grading = () => {
  return (
    
    <Container className="py-5"  id="about-us">
    <Row className="mb-4">
      <Col>
        <h1 className="text-center homepage-head" >
          Welcome to Writers Wright Grading
        </h1>
        <p className="text-center">
        The W is silent, but you can choose (W)right for excellence. Writers Wright Grading is dedicated to helping students achieve academic excellence. Our comprehensive essay grading service provides detailed feedback and expert guidance to elevate your writing to the next level. Whether you are a high school student, college student, or a professional, our experienced team is here to support you every step of the way.
        </p>
      </Col>
    </Row>

    <Row className="mb-5">
      <Col>
        <h2 style={{color:"var(--primary)",fontWeight:"700"}}>Why Choose Writers Wright Grading?</h2>
      </Col>
    </Row>

    <Row className="mb-4">
      <Col md={12}>
      <h1 className="">
        <span style={{fontSize:"50px",color: 'var(--secondary)'}}>1 </span>
        <span className="" style={{ color: 'var(--primary)',fontWeight:"700" }}>Expert Reviewers</span>
        </h1>
         <p>
          Our team consists of professional educators, experienced writers, and academic experts who understand the nuances of effective writing. They provide insightful feedback tailored to your individual needs.
        </p>
      </Col>
    </Row>

    <Row className="mb-4">
      <Col md={12}>
      <h1 className="">
        <span style={{fontSize:"50px",color: 'var(--secondary)'}}>2 </span>
        <span className="" style={{ color: 'var(--primary)',fontWeight:"700" }}>Comprehensive Feedback</span>
        </h1>

        <p>
          Receive detailed, constructive comments on your essay’s structure, content, grammar, and style. We highlight strengths and pinpoint areas for improvement, ensuring you know exactly where to focus your efforts. Customized Rubrics: We use customized grading rubrics based on your specific requirements or academic standards. This ensures fair and consistent evaluations aligned with your educational goals.
        </p>
      </Col>
    </Row>

    <Row className="mb-4">
      <Col md={12} >
        <h1 className="">
        <span style={{fontSize:"50px",color: 'var(--secondary)'}}>3 </span>
        <span className="" style={{ color: 'var(--primary)',fontWeight:"700" }}>Quick Turnaround</span>
        </h1>
         <p>
          Need your essay graded quickly? We offer various turnaround times, including expedited services for those tight deadlines, without compromising on quality. Affordable Pricing: Our pricing is designed to be student-friendly, with various packages to suit different needs and budgets. Quality feedback should be accessible to everyone. Plagiarism Check: Worried about originality? Our plagiarism check service ensures your work is unique and free from any unintentional similarities with existing texts. Secure and Confidential: Your privacy is our priority. All submissions are handled with the utmost confidentiality, and your personal information is never shared.
        </p>
        </Col>
    
    </Row>
  </Container>
  );
}

export default Grading;
